const configMember = {
  member: {
    listLayout: "MemberListDefaultLayout",
    filterLayout: "MemberFilterDefaultLayout",
    paginationLayout: "PaginationDefaultLayout",

    getFunc: "getMember",
    listApiParamSet: {
      ip: 1,
      sp: 10,
      mt: "student",
      ss: 1,
    },
  },
  admin: {
    listLayout: "AdminListDefaultLayout",
    filterLayout: "AdminFilterDefaultLayout",
    paginationLayout: "PaginationDefaultLayout",

    getFunc: "getMember",
    listApiParamSet: {
      ip: 1,
      sp: 10,
      mt: "student",
      ss: 1
    },
  },
  studentDetail: {
    writeLayouts: ["MemberWriteDefaultLayout"],
    getFunc: "getMember",
    detailApiParamsSet: {mt: "student", opf: 1, opd: 1, ss: 1},
    getDetailParamsKey: "no",
    writeFunc: "updateMember",
    writeApiParamSet: {
      g_type: "student",
      mb_type: "normal",
    },
    parsingData: {
      introduce: "mb_memo",
      oneWord: "mp_one_word",
    },
    directUrl: "",
    directType: "",
    fileType: "profile",
    keyName: "mb_no",
    writeSuccessType: 1,
    writeFailTypes: {
      "-2": "권한이 없습니다.",
      "-3": "없는 회원입니다.",
      "-4": "탈퇴회원 입니다.",
      "-5": "회원 타입이 다릅니다.",
      "-6": "중복된 이메일입니다.",
      "-7": "중복된 전화번호입니다.",
    },
  },
  quit: {
    listLayout: "MemberListQuitLayout",
    filterLayout: "MemberFilterQuitLayout",
    paginationLayout: "PaginationDefaultLayout",

    getFunc: "getMember",
    listApiParamSet: {
      mt: "out",
      ip: 1,
      sp: 10,
      ss: 1
    },
  },
  reviewDetail: {
    detailLayout: "MemberDetailReviewLayout",
    getFunc: "getMember",
    detailApiParamSet: {
      mt: "student",
      ip: 0,
      opd: 1,
      opf: 1,
      fo: 1,
      re: 1,
      ss: 1
    },
  },
  premium: {
    listLayout: "MemberListPremiumLayout",
    filterLayout: "MemberFilterPremiumLayout",
    paginationLayout: "PaginationDefaultLayout",

    getFunc: "getPremiumMember",
    listApiParamSet: {
      ip: 1,
      sp: 10,
    },

    keyName: "mp_idx",
    deleteFunc: "deletePremiumMember",
    deleteApiParamsSet: {},
    deleteSuccessType: 1,
    deleteFailTypes: {},
    deleteAlertText: "정말 프리미엄 해지를 하시겠습니까?",
    deleteSuccessAlertText: "해지되었습니다.",
  },
  createPremium: {
    writeLayouts: ["MemberWritePremiumLayout"],
    getFunc: "",
    detailApiParamsSet: {},
    getDetailParamsKey: "",
    writeFunc: "createPremiumMember",
    writeApiParamSet: {},
    parsingData: {
      premiumMemberValue: "mb_no",
      premiumStart: "mp_start",
      premiumEnd: "mp_end",
    },
    directUrl: "",
    directType: "back",
    fileType: "",
    keyName: "mp_idx",
    writeSuccessType: 1,
    writeFailTypes: {
      "-200": "구독기간을 다시 설정해주세요.",
      "-113": "등록한 프리미엄 회원입니다.",
      "-514": "결제 회원입니다.",
    },
  },
  updatePremium: {
    writeLayouts: ["MemberWritePremiumLayout"],
    getFunc: "getPremiumMember",
    detailApiParamsSet: {ip: 0},
    getDetailParamsKey: "id",
    writeFunc: "updatePremiumMember",
    writeApiParamSet: {},
    parsingData: {
      premiumStart: "mp_start",
      premiumEnd: "mp_end",
    },
    directUrl: "",
    directType: "back",
    fileType: "",
    keyName: "mp_idx",
    writeSuccessType: 1,
    writeFailTypes: {
      "-200": "구독기간을 다시 설정해주세요.",
      "-113": "등록한 프리미엄 회원입니다.",
      "-514": "결제 회원입니다.",
    },

    deleteFunc: "deletePremiumMember",
    deleteApiParamsSet: {},
    deleteSuccessType: 1,
    deleteFailTypes: {},
    deleteAlertText: "정말 프리미엄 해지를 하시겠습니까?",
    deleteSuccessAlertText: "해지되었습니다.",
  },
  memberMail: {
    listLayout: "MemberListMailLayout",
    filterLayout: "MemberFilterDefaultLayout",
    paginationLayout: "PaginationNonBtnLayout",

    getFunc: 'getMember',
    listApiParamSet: {
      ip: 1,
      sp: 10,
      mt: 'student',
      ss: 1
    },
  },
  memberCoupon: {
    listLayout: 'MemberListCouponLayout',
    filterLayout: 'MemberFilterDefaultLayout',
    paginationLayout: 'PaginationNonBtnLayout',

    getFunc: 'getMember',
    listApiParamSet: {
      ip: 1,
      sp: 10,
      mt: 'student',
      ss: 1
    },
    postFunc: 'giveCouponMember',

  },
  memberModal: {
    listLayout: "MemberListModalLayout",
    filterLayout: "MemberFilterDefaultLayout",
    paginationLayout: "PaginationDefaultLayout",

    getFunc: "getMember",
    listApiParamSet: {
      ip: 1,
      sp: 10,
      mt: "student",
      ss: 1
    },
  },
  memberLiveClassModal: {
    listLayout: "MemberListLiveClassLayout",
    filterLayout: "MemberFilterLiveClassLayout",
    paginationLayout: "PaginationLiveClassLayout",

    getFunc: "getMember",
    listApiParamSet: {
      ip: 1,
      sp: 10,
      mt: "student",
      ss: 1,
    },

    keyName: 'mb_no',

    deleteFunc: "registStreamingStudent",
    deleteApiParamsSet: {},
    deleteSuccessType: 1,
    deleteFailTypes: {},
    deleteAlertText: "수강생으로 등록하시겠습니까?",
    deleteSuccessAlertText: "등록되었습니다.",
  },
}
import {memberType, memberSex} from "@/service/memberService";
import util from "@/mixins/util";

export default {
  methods: {
    returnMemberConfig(type) {
      return configMember[type];
    },
    returnMemberType(type, key = 'name') {
      let memberTypeObj = memberType[type];
      if (util.isEmpty(memberTypeObj)) {
        return '이메일'
      }
      return memberTypeObj[key];
    },
    returnMemberSexName(type, key = 'name') {
      let memberSexObj = memberSex[type];
      if (util.isEmpty(memberSexObj)) {
        return '';
      }
      return memberSexObj[key];
    },

  },
  filterConfig: {
    cr: {
      type: 'between',
      classname: 'filterDate'
    },
    out: {
      type: 'between',
      classname: 'filterOutDate'
    },
    ni: {
      type: 'query',
      classname: 'searchInput',
    },
    mid: {
      type: 'query',
      classname: 'searchInput',
    },
    em: {
      type: 'query',
      classname: 'searchInput',
    },
    st: {
      type: 'between',
      classname: 'filterStartDate'
    },
    en: {
      type: 'between',
      classname: 'filterEndDate'
    },
    residence: {
      type: 'query',
      classname: 'searchLiveCountry',
    },
    cid: {
      type: 'query',
      classname: 'searchCountry',
    },
    ty: {
      type: 'query',
      classname: 'langType',
    },
    plid: {
      type: 'query',
      classname: 'searchLang',
    },
    tlid: {
      type: 'query',
      classname: 'searchStudyLang',
    },
  }
}
